import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapMarkerAlt,
  faEnvelope,
  faPhoneAlt,
  faWhatsapp
} from '@fortawesome/free-solid-svg-icons';
import {
  faGooglePlusG,
  faTwitter,
  faFacebookF,
  faOdnoklassniki,
  faVk,
  faInstagram
} from '@fortawesome/free-brands-svg-icons';
import { useLanguage } from '../../contexts/LanguageContext';

const Footer = () => {
  const { currentLanguage } = useLanguage();

  const [activeUsers, setActiveUsers] = useState(null);
  const [totalUsers, setTotalUsers] = useState(null);

  useEffect(() => {

    const fetchStats = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:4000';
        const response = await fetch(`${apiUrl}/api/stats`);
        if (response.ok) {
          const data = await response.json();
          setTotalUsers(data.totalVisits);
          setActiveUsers(data.activeUsers);
        }
      } catch (error) {
        console.error("Failed to fetch visitor stats", error);
      }
    };

    fetchStats();

    const interval = setInterval(fetchStats, 15000);

    return () => clearInterval(interval);
  }, []);

  const translations = {
    kz: {
      contact: "БАЙЛАНЫС",
      address: "050013, Қазақстан Республикасы<br />Алматы қаласы, Абай даңғылы, 14",
      reception: "+7 (727) 267-28-83 - қабылдау бөлмесі",
      pressSecretary: "+7 (700) 263-45-39 - баспасөз хатшысы",
      associations: "КІТАПХАНАЛЫҚ ҚАУЫМДАСТЫҚТАР",
      kazakhLibraryUnion: "ҚАЗАҚСТАНДЫҚ КІТАПХАНАЛЫҚ ОДАҚ",
      ifla: "Кітапханалық қауымдастықтар мен мекемелердің халықаралық федерациясы",
      eurasianAssembly: "Еуразия Кітапханалық Ассамблеясы",
      russianAssociation: "Ресей Кітапханалық Ассоциациясы (РКА)",
      electronicConsortium: "Электронды-ақпараттық консорциум Ассоциациясы",
      copyright: "© 2013-2026 Қазақстан Республикасының Ұлттық Кітапханасы. Барлық құқықтар сақталған.",
      activeUsers: "Қазіргі уақытта сайтта: ",
      totalUsers: "Барлық уақыттағы кірулер саны: "
    },
    ru: {
      contact: "КОНТАКТЫ",
      address: "050013, Республика Казахстан<br />г. Алматы, проспект Абая, 14",
      reception: "+7 (727) 267-28-83 - приемная",
      pressSecretary: "+7 (700) 263-45-39 - пресс-секретарь",
      associations: "БИБЛИОТЕЧНЫЕ СООБЩЕСТВА",
      kazakhLibraryUnion: "КАЗАХСТАНСКИЙ БИБЛИОТЕЧНЫЙ СОЮЗ",
      ifla: "Международная федерация библиотечных ассоциаций и учреждений",
      eurasianAssembly: "Евразийская Библиотечная Ассамблея",
      russianAssociation: "Российская Библиотечная Ассоциация (РБА)",
      electronicConsortium: "Ассоциация электронно-информационного консорциума",
      copyright: "© 2013-2026 Национальная Библиотека Республики Казахстан. Все права защищены.",
      activeUsers: "Сейчас на сайте: ",
      totalUsers: "Посещений за все время: "
    },
    en: {
      contact: "CONTACT",
      address: "050013, Republic of Kazakhstan<br />Almaty city, Abai Avenue, 14",
      reception: "+7 (727) 267-28-83 - reception",
      pressSecretary: "+7 (700) 263-45-39 - press secretary",
      associations: "LIBRARY COMMUNITIES",
      kazakhLibraryUnion: "KAZAKHSTAN LIBRARY UNION",
      ifla: "International Federation of Library Associations and Institutions",
      eurasianAssembly: "Eurasian Library Assembly",
      russianAssociation: "Russian Library Association (RLA)",
      electronicConsortium: "Electronic Information Consortium Association",
      copyright: "© 2013-2026 National Library of the Republic of Kazakhstan. All rights reserved.",
      activeUsers: "Currently active users: ",
      totalUsers: "Total visits: "
    }
  };

  const t = translations[currentLanguage] || translations.kz;

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-title">{t.contact}</h3>
          <div className="contact-info">
            <div className="contact-item">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <p dangerouslySetInnerHTML={{ __html: t.address }}></p>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} />
              <p>org.nbrk@mail.kz</p>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faPhoneAlt} />
              <p>{t.reception}<br />{t.pressSecretary}</p>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} />
              <p>ulttykktapkhana@mail.kz</p>
            </div>
            <div className="contact-item">
              <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path>
              </svg>
              <p>+7 (776) 065 1367</p>
            </div>
            <div className='contact-item'>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <a href='https://go.2gis.com/qvO4H' target='_blank'>2GIS</a>
            </div>
          </div>
        </div>
        <div className="footer-section footer-logo">
          <div className="logo-container">
            <a href="/">
              <img src='/assets/images/logolib.png' alt="Library Logo" />
            </a>
          </div>
        </div>
        <div className="footer-section">
          <h3 className="footer-title">{t.associations}</h3>
          <ul className="association-links">
            <li><a href="#">{t.kazakhLibraryUnion}</a></li>
            <li><a href="http://www.ifla.org">{t.ifla}</a></li>
            <li><a href="https://bae.rsl.ru">{t.eurasianAssembly}</a></li>
            <li><a href="http://www.rba.ru">{t.russianAssociation}</a></li>
            <li><a href="https://neicon.ru">{t.electronicConsortium}</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-main">
          <p className="footer-copyright">{t.copyright}</p>
          <div className="social-links">
            <a href="https://workspaceupdates.googleblog.com/2023/04/new-community-features-for-google-chat-and-an-update-currents%20.html" className="social-link">
              <FontAwesomeIcon icon={faGooglePlusG} />
            </a>
            <a href="https://x.com/home" className="social-link">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://www.facebook.com/nlrk.kz/" className="social-link">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://ok.ru" className="social-link">
              <FontAwesomeIcon icon={faOdnoklassniki} />
            </a>
            <a href="https://vk.com/kitapkhana1931" className="social-link">
              <FontAwesomeIcon icon={faVk} />
            </a>
            <a href="https://www.instagram.com/ulttyq_kitapkhana/?hl=ru%2F" className="social-link">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </div>
        <div className="footer-stats-container">
          <p>{t.activeUsers}{activeUsers !== null ? activeUsers : "В обработке..."}</p>
          <p>{t.totalUsers}{totalUsers !== null ? totalUsers.toLocaleString() : "В обработке..."}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;